module.exports = __webpack_public_path__ + "fonts/fa-regular-400.4776aa52.woff";